import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import { Tooltip } from 'bootstrap';

const BillsWay = () => {
    const [title, setTitle] = useState("Ingresos de Camino");
    const [loading, setLoading] = useState(false);
    const [bills, setBills] = useState([]);
    const [bill_id, setBillId] = useState(0);
    const [fecha_viaje, setFechaViaje] = useState('');
    const [branch, setBranch] = useState('');
    const [branches, setBranches] = useState([]);
    const [ingreso, setIngreso] = useState('');
    const [usuario_ingresa, setUsuarioIngresa] = useState('');
    const [fecha_hora_ingreso, setFechaHoraIngreso] = useState('');
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);

    const [schedule, setSchedule] = useState('');
    const [schedules, setSchedules] = useState([]);
    const [anotaciones, setAnotaciones] = useState('');

    const [filteredSchedules, setFilteredSchedules] = useState([]);
    const [occupiedSchedules, setOccupiedSchedules] = useState([]);

    const [filterStartDate, setFilterStartDate] = useState('');
    const [filterEndDate, setFilterEndDate] = useState('');
    const [filterBranch, setFilterBranch] = useState('');
    const [filterUser, setFilterUser] = useState('');
    const [filterUnit, setFilterUnit] = useState('');
    const [usuarios, setUsuarios] = useState([]);
    const [units, setUnits] = useState([]);
    const [groupByUnit, setGroupByUnit] = useState(false);

    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;
    const [rol_id, setRolId] = useState(0);

    // Initialize component
    useEffect(() => {
        getAll();

        // Initialize tooltips
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.forEach(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });

        // Set current user info
        const user = JSON.parse(localStorage.getItem('dataUser') || '{}');
        if (user) {
            setUsuarioIngresa(`${user.user_id}`.trim());
            setRolId(user.rol_id);
        }

        fetch(ENDPOINT + "get-all-branchs/2")
            .then(res => res.json())
            .then(data => setBranches(data.data))
            .catch(err => console.error('Error al traer branches:', err));

        fetch(ENDPOINT + "get-all-schedules/2")
            .then(res => res.json())
            .then(data => setSchedules(data.data))
            .catch(err => console.error('Error al traer branches:', err));

        fetch(ENDPOINT + "get-all-users?status_filter=2", {
            method: 'POST',  
            headers: {
                'Content-Type': 'application/json',
                
            },
            body: JSON.stringify({}) 
        })
            .then(res => res.json())
            .then(data => setUsuarios(data.data || []))
            .catch(err => console.error('Error al traer usuarios:', err));

        fetch(ENDPOINT + "get-all-units-billways/2")
            .then(res => res.json())
            .then(data => setUnits(data.data || []))
            .catch(err => console.error('Error al traer unidades:', err));

    }, []);

    // Función para obtener horarios ocupados
    const getOccupiedSchedules = async (fecha, branchId) => {
        if (!fecha || !branchId) {
            setOccupiedSchedules([]);
            return;
        }

        try {
            const response = await axios.post(ENDPOINT + 'get-occupied-schedules', {
                fecha_viaje: fecha,
                branch_id: branchId
            });
            
            if (response.data.res) {
                setOccupiedSchedules(response.data.data || []);
            }
        } catch (error) {
            console.error('Error al obtener horarios ocupados:', error);
            setOccupiedSchedules([]);
        }
    };

    // Efecto para obtener horarios ocupados cuando cambia fecha o branch
    useEffect(() => {
        if (fecha_viaje && branch) {
            getOccupiedSchedules(fecha_viaje, branch);
        } else {
            setOccupiedSchedules([]);
        }
    }, [fecha_viaje, branch]);

    // Efecto para filtrar horarios cuando cambian fecha, branch, schedules u occupiedSchedules
    useEffect(() => {
        if (branch) {
            const filtered = schedules.filter(item => {
                const baseConditions = item.state == 1 && item.branch_id == branch && item.status == 1;
                
                // Verificar si el horario ya está ocupado
                const isOccupied = occupiedSchedules.includes(item.schedule_id);
                
                if (fecha_viaje) {
                    return baseConditions && 
                           (item.date === fecha_viaje || item.date === "0000-00-00") &&
                           !isOccupied; // Excluir horarios ocupados
                }

                return baseConditions && 
                       item.date === "0000-00-00" && 
                       !isOccupied; // Excluir horarios ocupados
            });

            setFilteredSchedules(filtered);

            // Si el horario actual está ocupado, limpiarlo
            if (schedule && occupiedSchedules.includes(parseInt(schedule))) {
                setSchedule('');
            }
            
            // Si solo hay un horario disponible y no hay uno seleccionado, seleccionarlo
            if (filtered.length === 1 && !schedule) {
                setSchedule(filtered[0].schedule_id);
            }
        } else {
            setFilteredSchedules([]);
        }
    }, [fecha_viaje, branch, schedules, schedule, occupiedSchedules]);

    const getMexicoDateTime = () => {
        const now = new Date();
        const options = {
            timeZone: 'America/Mexico_City',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        };

        const formatter = new Intl.DateTimeFormat('es-MX', options);
        const parts = formatter.formatToParts(now);

        const year = parts.find(p => p.type === 'year').value;
        const month = parts.find(p => p.type === 'month').value;
        const day = parts.find(p => p.type === 'day').value;
        const hour = parts.find(p => p.type === 'hour').value;
        const minute = parts.find(p => p.type === 'minute').value;

        return `${year}-${month}-${day}T${hour}:${minute}`;
    };

    useEffect(() => {
        setFechaHoraIngreso(getMexicoDateTime());
    }, []);

    // Clear form fields
    const clearField = () => {
        setBillId(0);
        setFechaViaje('');
        setBranch('');
        setIngreso('');
        setSchedule('');
        setAnotaciones('');
        setOccupiedSchedules([]);
        // Keep usuario_ingresa and fecha_hora_ingreso as they are auto-filled
    };

    // Handle new button click
    const handleNew = () => {
        setTitle("Agregar Ingreso");
        clearField();
        // Set current date and time when opening the modal
        setFechaHoraIngreso(getMexicoDateTime());
    };

    // Get all bills
    const getAll = async (filters = {}) => {
        setLoading(true);
        // variables

        try {
            // Destroy existing DataTable if it exists
            if ($.fn.DataTable.isDataTable('.main')) {
                $('.main').DataTable().destroy();
            }

            const response = await axios.post(ENDPOINT + 'get-all-bills-way', filters);
            setBills(response.data.data || []);

            // Update active/inactive counts
            const activeBills = response.data.data.filter((e) => e.status === 1).length;
            const inactiveBills = response.data.data.filter((e) => e.status === 0).length;
            setActive(activeBills);
            setInactive(inactiveBills);

            setBills(response.data.data || []);
            // Initialize DataTable only when NOT grouping by unit
            if (!groupByUnit) {
                setTimeout(() => {
                    $('.main').DataTable({
                        searching: true,
                        destroy: true,
                        retrieve: true,
                        pageLength: 50,
                        responsive: false,
                        autoWidth: false,
                        paging: true,
                        ordering: true,
                        sortable: true,
                        processing: false,
                        serverSide: false,
                        bInfo: true,
                        language: {
                            "decimal": "",
                            "emptyTable": "No hay datos disponibles en la tabla",
                            "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                            "infoEmpty": "Mostrando 0 a 0 de 0 registros",
                            "infoFiltered": "(filtrado de _MAX_ registros en total)",
                            "infoPostFix": "",
                            "thousands": ",",
                            "lengthMenu": "Mostrar _MENU_ registros",
                            "loadingRecords": "Cargando...",
                            "processing": "Procesando...",
                            "search": "Buscar:",
                            "zeroRecords": "No se encontraron registros coincidentes",
                            "paginate": {
                                "first": "Primero",
                                "last": "Último",
                                "next": "Siguiente",
                                "previous": "Anterior"
                            },
                            "aria": {
                                "sortAscending": ": activar para ordenar la columna de manera ascendente",
                                "sortDescending": ": activar para ordenar la columna de manera descendente"
                            }
                        },
                        order: [[0, 'desc']]
                    });
                }, 100);
            }

        } catch (error) {
            console.error('Error al cargar los registros:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron cargar los registros. Por favor, intente nuevamente.'
            });
        } finally {
            setLoading(false);
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // Create a regular object instead of FormData
            const requestData = {
                fecha_viaje,
                branch,
                ingreso,
                usuario_ingresa,
                fecha_hora_ingreso,
                schedule_id: schedule,
                anotaciones
            };

            // Debug what we're sending
            console.log('Sending data:', requestData);

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            };

            let response;

            if (bill_id === 0) {
                // Create new bill
                response = await axios.post(
                    ENDPOINT + 'save-bill-way',
                    requestData,
                    config
                );
            } else {
                // Update existing bill
                response = await axios.put(
                    ENDPOINT + 'update-bill-way/' + bill_id,
                    requestData,
                    config
                );
            }

            // Close modal and refresh data
            $('#closemodal').click();
            await getAll();

            // Show success message
            Swal.fire({
                icon: 'success',
                title: TITLEALERT,
                text: response.data.message || 'Operación realizada con éxito',
                showConfirmButton: false,
                timer: 3000
            });

        } catch (error) {
            console.error('Error:', error);
            console.error('Error response:', error.response);

            const errorMsg = error.response?.data?.message ||
                error.response?.data?.msg ||
                'Error al procesar la solicitud';

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMsg
            });
        } finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        const filters = {
            start_date: filterStartDate,
            end_date: filterEndDate,
            branch_id: filterBranch,
            user: filterUser,
            unit_id: filterUnit
        };
        getAll(filters);
    };

    // When toggling grouping, reload data so UI re-renders grouped/ungrouped correctly
    useEffect(() => {
        handleFilter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupByUnit]);

    // Toggle bill status
    const toggleSwitch = async (id) => {
        try {
            setLoading(true);
            const response = await axios.get(ENDPOINT + 'get-bill-status/' + id);
            await getAll();

            Swal.fire({
                icon: 'success',
                title: TITLEALERT,
                text: response.data.msg,
                showConfirmButton: false,
                timer: 3000
            });

        } catch (error) {
            console.error('Error al cambiar el estado:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo cambiar el estado del registro'
            });
        } finally {
            setLoading(false);
        }
    };

    // Handle edit button click
    const handleEdit = async (id) => {
        setTitle("Editar Ingreso");
        setLoading(true);

        try {
            const response = await axios.get(ENDPOINT + 'get-bill-way/' + id);
            const bill = response.data.data;

            // First, set the branch and wait for it to update
            if (bill.branch_id) {
                setBranch(bill.branch_id);
            }

            if (bill.fecha_viaje) {
                setFechaViaje(bill.fecha_viaje);
            }

            // Wait for the schedules to be filtered based on the branch and fecha
            setTimeout(() => {
                // Now set the schedule after the branch is set and schedules are filtered
                if (bill.schedule_id) {
                    setSchedule(String(bill.schedule_id));
                }
            }, 200);

            // Set other form values
            setBillId(bill.id_bills_way);
            setIngreso(bill.ingreso || '');
            setAnotaciones(bill.notes || '');

            // Set the date and time from the API response
            if (bill.fecha_ingreso) {
                const date = new Date(bill.fecha_ingreso);
                const formattedDate = date.toISOString().slice(0, 16);
                setFechaHoraIngreso(formattedDate);
            }

        } catch (error) {
            console.error('Error al cargar el registro:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo cargar el registro para editar: ' + (error.response?.data?.msg || error.message)
            });
        } finally {
            setLoading(false);
        }
    };

    // Handle delete button click
    const handleDelete = async (id, name) => {
        const result = await Swal.fire({
            title: '¿Está seguro?',
            text: `Está a punto de eliminar el registro ${name}. Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                setLoading(true);
                const response = await axios.delete(ENDPOINT + 'delete-bill-way/' + id);
                await getAll();

                Swal.fire({
                    icon: 'success',
                    title: '¡Eliminado!',
                    text: response.data.msg,
                    showConfirmButton: false,
                    timer: 3000
                });

            } catch (error) {
                console.error('Error al eliminar el registro:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo eliminar el registro. Por favor, intente nuevamente.'
                });
            } finally {
                setLoading(false);
            }
        }
    };

    // Format date for display
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const options = {
            timeZone: 'America/Mexico_City',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        return new Date(dateString).toLocaleString('es-MX', options);
    };

    // Handle print button click
    const handlePrint = () => {
        const table = $('.main').DataTable();
        const data = table.rows({ search: 'applied' }).data();

        if (data.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No hay datos para imprimir',
                text: 'No hay registros que coincidan con la búsqueda actual',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        window.print();
    };

    // Handle page refresh
    const handleRefresh = () => {
        window.location.reload();
    };

    // Función para agrupar registros por unidad
    const groupBillsByUnit = () => {
        if (!groupByUnit) {
            return bills;
        }
        
        const grouped = {};
        bills.forEach(bill => {
            const unitName = bill.unit_name || 'Sin Unidad';
            if (!grouped[unitName]) {
                grouped[unitName] = [];
            }
            grouped[unitName].push(bill);
        });
        
        // Convertir a array de objetos con el nombre de la unidad como clave
        return Object.entries(grouped).map(([unitName, billList]) => ({
            unitName,
            bills: billList,
            total: billList.reduce((sum, bill) => sum + parseFloat(bill.ingreso || 0), 0)
        }));
    };

    // Agrega esta función antes del return
    const handleExportExcel = () => {
        if (!bills || bills.length === 0) return;

        // Encabezados de la tabla (ajusta si cambias columnas)
        const headers = [
            "ID", "Fecha Viaje", "Sucursal", "Horario", "Unidad", "Conductor", "Tickets", "Ingreso", "Anotaciones", "Usuario", "Fecha/Hora Ingreso"
        ];

        // Construir filas para todos los registros en `bills` (esto respeta los filtros aplicados por getAll)
        const rows = bills.map(b => {
            const userFullName = ((b.name || '') + (b.last_name ? ' ' + b.last_name : '')).trim() || 'N/A';
            const conductor = b.driver_name ? (b.driver_name + (b.driver_last_name ? ' ' + b.driver_last_name : '')) : (b.driver_name || 'N/A');
            return [
                b.id_bills_way || '',
                b.fecha_viaje || '',
                b.namesucursal || b.branch_id || '',
                b.time || '',
                b.driver_name || b.driver_name || 'N/A',
                 b.unit_name || 'Sin Unidad',
                b.ticket_count || 0,
                `$${parseFloat(b.ingreso || 0).toFixed(2)}`,
                b.notes || '',
                userFullName,
                formatDate(b.fecha_ingreso) || ''
            ];
        });

        // Construir tabla HTML
        const tableRowsHtml = rows.map(r => `<tr>${r.map(c => `<td>${c}</td>`).join('')}</tr>`).join('');
        const tableHTML = `
            <table>
                <thead>
                    <tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>
                </thead>
                <tbody>
                    ${tableRowsHtml}
                </tbody>
            </table>
        `;

        const filename = 'ingresos-camino.xls';
        const dataType = 'application/vnd.ms-excel;charset=utf-8';
        const blob = new Blob(['\ufeff', tableHTML], { type: dataType }); // prepend BOM for Excel compatibility
        const downloadLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    };

    useEffect(() => {
        document.title = `PANEL ADMIN - SALINACRUCENSES - ${title}`;
    }, [title]);

    return (
        <div className="content-wrapper">
            {/* Content Header */}
            <ContentHeader title="Ingresos de Camino" />

            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    {/* Stats cards */}
                    <div className="row">
                        <div className="col-lg-6 col-6">
                            <div className="small-box bg-info">
                                <div className="inner">
                                    <h3>{bills.length}</h3>
                                    <p>Total de Registros</p>
                                </div>
                                <div className="icon">
                                    <i className="fas fa-file-invoice"></i>
                                </div>
                                <a href="#" className="small-box-footer">
                                    <i className="fas fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>

                        <div className="col-lg-6 col-6">
                            <div className="small-box bg-danger">
                                <div className="inner">
                                    <h3>
                                        ${bills.reduce((sum, bill) => sum + parseFloat(bill.ingreso || 0), 0).toFixed(2)}
                                    </h3>
                                    <p>Total en Ingresos</p>
                                </div>
                                <div className="icon">
                                    <i className="fas fa-dollar-sign"></i>
                                </div>
                                <a href="#" className="small-box-footer">
                                    <i className="fas fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Main card */}
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Lista de Ingresos</h3>
                            <div className="card-tools">
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label>Fecha Inicio</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={filterStartDate}
                                            onChange={(e) => setFilterStartDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Fecha Fin</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={filterEndDate}
                                            onChange={(e) => setFilterEndDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-control"
                                            value={filterBranch}
                                            onChange={(e) => setFilterBranch(e.target.value)}
                                        >
                                            <option value="">Todas las sucursales</option>
                                            {branches.map(branch => (
                                                <option key={branch.branch_id} value={branch.branch_id}>
                                                    {branch.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-control"
                                            value={filterUnit}
                                            onChange={(e) => setFilterUnit(e.target.value)}
                                        >
                                            <option value="">Todas las unidades</option>
                                            {units.map(unit => (
                                                <option key={unit.unit_id} value={unit.unit_id}>
                                                    {unit.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-control"
                                            value={filterUser}
                                            onChange={(e) => setFilterUser(e.target.value)}
                                        >
                                            <option value="">Todos los usuarios</option>
                                            {usuarios.map(user => (
                                                <option key={user.user_id} value={user.user_id}>
                                                    {user.name} {user.last_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleFilter}
                                        >
                                            <i className="fas fa-filter"></i> Filtrar
                                        </button>
                                        <button
                                            className="btn btn-default ml-2"
                                            onClick={() => {
                                                setFilterStartDate('');
                                                setFilterEndDate('');
                                                setFilterBranch('');
                                                setFilterUser('');
                                                setFilterUnit('');
                                                getAll();
                                            }}
                                        >
                                            <i className="fas fa-times"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id="groupByUnitCheckbox"
                                                checked={groupByUnit}
                                                onChange={(e) => setGroupByUnit(e.target.checked)}
                                            />
                                            <label className="custom-control-label" htmlFor="groupByUnitCheckbox">
                                                Agrupar por Unidad
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-tool"
                                    onClick={handleRefresh}
                                    data-bs-toggle="tooltip"
                                    title="Recargar"

                                >
                                    <i className="fas fa-sync-alt"></i>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    onClick={handleNew}
                                >
                                    <i className="fas fa-plus"></i> Nuevo Ingreso
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success ml-2"
                                    onClick={handleExportExcel}
                                    data-bs-toggle="tooltip"
                                    title="Exportar a Excel"
                                >
                                    <i className="fa fa-file-excel"></i> Exportar
                                </button>
                            </div>
                        </div>

                        <div className="card-body">
                            <table id="bills-table" className="table table-bordered table-striped main">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Fecha Viaje</th>
                                        <th>Sucursal</th>
                                        <th>Horario</th>
                                        <th>Unidad</th>
                                        <th>Conductor</th>
                                        <th>Ocupacion</th>
                                        <th>Ingreso</th>
                                        <th>Anotaciones</th>
                                        <th>Usuario</th>
                                        <th>Fecha/Hora Ingreso</th>
                                        {/* <th>Estado</th> */}
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bills.map((bill) => (
                                        <tr key={bill.id_bills_way}>
                                            <td>{bill.id_bills_way}</td>
                                            <td>{bill.fecha_viaje}</td>
                                            <td>{bill.namesucursal || bill.branch_id}</td>
                                            <td>{bill.time || 'N/A'}</td>
                                            <td>{bill.unit_name || 'N/A'}</td>
                                            <td>{bill.driver_name || 'N/A'}</td>
                                            <td>{bill.ticket_count || 0}</td>
                                            <td>${parseFloat(bill.ingreso || 0).toFixed(2)}</td>
                                            <td>{bill.notes || 'Sin notas'}</td>
                                            <td>{bill.name + ' ' + bill.last_name || 'N/A'}</td>
                                            <td>{formatDate(bill.fecha_ingreso)}</td>
                                            <td>
                                                <div className="btn-group">
                                                    <button
                                                        type="button"
                                                        className="btn btn-info btn-sm"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        onClick={() => handleEdit(bill.id_bills_way)}
                                                        title="Editar"
                                                        onMouseEnter={(e) => {
                                                            new Tooltip(e.target, {
                                                                title: "Editar",
                                                                placement: "top",
                                                                trigger: "hover"
                                                            }).show();
                                                        }}
                                                    >
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    {/* if si el rol es 1 */}
                                                    {rol_id === 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => handleDelete(bill.id_bills_way, bill.id_bills_way)}
                                                            data-bs-toggle="tooltip"
                                                            title="Eliminar"
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>

            {/* Add/Edit Modal */}
            <div className="modal fade" id="modal-default">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{title}</h4>

                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Fecha de Viaje</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={fecha_viaje}
                                        onChange={(e) => {
                                            const selectedDate = e.target.value;
                                            setFechaViaje(selectedDate);
                                        }}
                                        required
                                    />
                                    <small className="text-muted">
                                        {occupiedSchedules.length > 0 && 
                                            `${occupiedSchedules.length} horario(s) ya registrado(s) para esta fecha y sucursal`
                                        }
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label>Selecciona una sucursal</label>
                                    <select className="form-control"
                                        value={branch}
                                        onChange={(e) => setBranch(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Selecciona --</option>
                                        {branches.map(branchItem => (
                                            <option key={branchItem.branch_id} value={branchItem.branch_id}>
                                                {branchItem.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Horario</label>
                                    <select
                                        className="form-control"
                                        value={schedule}
                                        onChange={(e) => setSchedule(e.target.value)}
                                        required
                                        disabled={!branch}
                                    >
                                        <option value="">-- Selecciona un horario --</option>
                                        {filteredSchedules.map(item => (
                                            <option key={item.schedule_id} value={item.schedule_id}>
                                                {item.time.split(':').slice(0, 2).join(':')}
                                                {item.date === "0000-00-00" && ""}
                                            </option>
                                        ))}
                                    </select>
                                    {branch && filteredSchedules.length === 0 && (
                                        <small className="text-danger">
                                            {fecha_viaje && occupiedSchedules.length > 0 
                                                ? 'Todos los horarios ya están registrados para esta fecha y sucursal'
                                                : 'No hay horarios disponibles para esta sucursal' + (fecha_viaje ? ' y fecha' : '')
                                            }
                                        </small>
                                    )}
                                    {branch && filteredSchedules.length > 0 && occupiedSchedules.length > 0 && (
                                        <small className="text-warning">
                                            Se muestran solo horarios disponibles. {occupiedSchedules.length} horario(s) ocupado(s).
                                        </small>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label>Ingreso</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={ingreso}
                                        onChange={(e) => setIngreso(e.target.value)}
                                        placeholder="Ingrese el monto"
                                        step="0.01"
                                        min="0"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Anotaciones</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={anotaciones}
                                        onChange={(e) => setAnotaciones(e.target.value)}
                                        placeholder="Escribe observaciones adicionales"
                                    />
                                </div>

                                <div className="form-group" style={{ display: 'none' }}>
                                    <label>Usuario que ingresa</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={usuario_ingresa}
                                        readOnly
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Fecha y Hora de Ingreso</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        value={fecha_hora_ingreso}
                                        onChange={(e) => {
                                            const date = new Date(e.target.value);
                                            const mexicoTime = new Date(date.toLocaleString('es-MX', { timeZone: 'America/Mexico_City' }));
                                            setFechaHoraIngreso(mexicoTime.toISOString().slice(0, 16));
                                        }}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="modal-footer justify-content-between">
                                <button type="button" className="btn btn-default" data-bs-dismiss="modal" id="closemodal">
                                    Cerrar
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={loading || !schedule}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Procesando...
                                        </>
                                    ) : (
                                        'Guardar Cambios'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Loader */}
            {loading && <Loader />}
        </div>
    );
};

export default BillsWay;